module.exports = {"path":["Dashboard","Accounting","Accounting Management"]}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/accounting/group/index.json
// module id = PcOV
// module chunks = 58